<script lang="ts" setup>
import IftaLabel from 'primevue/iftalabel';
import AdaptiveDialog from '../AdaptiveDialog.vue';
import SrInputNumber from '@/components/SrInputNumber.vue';
import Message from 'primevue/message';
import Button from 'primevue/button';
import { nextTick, ref } from "vue"
import { Form, FormField, type FormSubmitEvent } from "@primevue/forms";
import { zodResolver } from '@primevue/forms/resolvers/zod';
import { z } from 'zod';
import { useRoute } from 'vue-router';
import { isNumber } from 'lodash';
import type { FormInstance } from '@primevue/forms';
import { useTemplateRef } from 'vue';

const route = useRoute()
const settingsForm = useTemplateRef<FormInstance>('settingsForm');

const AMOUNT_MIN = 20
const AMOUNT_MAX = 5000
const params = route.params

const visible = ref(false)
const toggle = async () => {
  visible.value = !visible.value
  if (visible.value) {
    await nextTick()
    if (params.amount) {
      const amTemp = Number(params.amount)
      settingsForm.value?.setFieldValue('amount', '444')
      if (isNumber(amTemp)) {
        settingsForm.value?.setFieldValue('amount', amTemp.toString())
      }
    }
  }
}
defineExpose({
  toggle
})

const resolver = ref(zodResolver(
  z.object({
    amount: z.coerce.number().min(AMOUNT_MIN, { message: 'modal.updateAmount.errors.minAmountError' }).max(AMOUNT_MAX, { message: 'modal.updateAmount.errors.maxAmountError' }),
  })
));

const initialValues = {
  amount: null,
}
const emits = defineEmits(['submit'])

const submit = (e: FormSubmitEvent) => {
  return emits('submit', e)
}
</script>

<template>
  <AdaptiveDialog class="mt-10 lg:mt-20" v-model:visible="visible" modal pt:root="w-100" pt:content="p-2"
    pt:header="px-4 py-1" :header="$t('modal.updateAmount.title')">
    <Form ref="settingsForm" v-slot="$form" :resolver="resolver" :initialValues="initialValues" @submit="submit"
      class="grid grid-cols-1 gap-3">
      <FormField v-slot="$field" name="amount">
        <IftaLabel>
          <SrInputNumber type="text" fluid :placeholder="$t('modal.updateAmount.amount')" :loading="true" />
          <label>{{ $t('modal.updateAmount.amount') }}</label>
        </IftaLabel>
        <Message v-if="$field?.invalid" severity="error" size="small" variant="simple">{{ $t($field.error?.message,
          { min: AMOUNT_MIN, max: AMOUNT_MAX }) }}
        </Message>
      </FormField>
      <Button type="submit" :disabled='$form?.amount?.value == params.amount' severity="secondary"
        :label="$t('save')" />
    </Form>
  </AdaptiveDialog>
</template>
